<template>
  <v-img
    class="rounded-lg"
    :src="image"
    :height="height"
    :width="width"
    :contain="contain"
    :lazy-src="image"
    :loading="loading"
    :class="{
      'rounded-lg': rounded,
    }"
  >
    <template v-slot:placeholder>
      <v-row class="fill-height ma-0" align="center" justify="center">
        <v-img class="rounded-lg" src="/images/no_photo.jpg" contain></v-img>
      </v-row>
    </template>
  </v-img>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
    };
  },
  props: {
    img: { required: true },
    contain: { type: Boolean, default: false },
    height: { type: String, default: "50" },
    width: { type: String, default: "50" },
    rounded: { type: Boolean, default: false },
  },
  computed: {
    image() {
      return Help.img(this.img);
    },
  },
};
</script>

<style></style>
